import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import _isEqual from 'lodash/isEqual';

import { usePrevious } from 'hooks';
import CompanyTable from './CompanyTable';
import LoaderBar from 'components/LoaderBar';
import SearchWithFilters from 'components/SearchWithFilters';
import DashboardContainer from 'components/DashboardContainer';
import {
  companyAllSelector,
  getCompanies,
  resetSearch,
  searchCompanies,
  setParams,
  setSearchTerm,
} from 'redux/slices/company';
import Button from 'components/Button';
import { companyTable as TEXT } from 'locales/en/company';
import PATHS from 'routes/paths';

const Companies = () => {
  const dispatch = useDispatch();

  const { data, pagination, params, isLoading, searchTerm } = useSelector(
    (state) => companyAllSelector(state)
  );

  const prevParams = usePrevious(params);
  const prevSearchTerm = usePrevious(searchTerm);

  useEffect(() => {
    dispatch(getCompanies());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      (prevParams !== null && !_isEqual(params, prevParams)) ||
      (!!prevSearchTerm && searchTerm === '')
    ) {
      dispatch(getCompanies());
    }
  }, [dispatch, params, prevParams, prevSearchTerm, searchTerm]);

  const onChangePerPage = (per_page) => {
    dispatch(
      setParams({
        per_page,
        page: 1,
      })
    );
    dispatch(getCompanies());
  };

  const onChangePage = ({ selected }) => {
    dispatch(
      setParams({
        page: selected + 1,
      })
    );
    dispatch(getCompanies());
  };

  const onChangeSearchTerm = (event) => {
    dispatch(setSearchTerm(event.target.value || ''));
  };

  const onSearch = () => {
    dispatch(searchCompanies());
  };

  const onClearInput = () => {
    dispatch(resetSearch());
    dispatch(getCompanies());
  };

  return (
    <DashboardContainer
      header={TEXT.header}
      rightContent={
        <div>
          <Button
            className="btn-secondary mr-6 h-10 w-48 p-0 text-sm"
            title={TEXT.syncStripeAccount}
          />
          <Link to={PATHS.companiesNew}>
            <Button
              className="btn-secondary h-10 w-40 p-0 text-sm"
              title={TEXT.createCompany}
            />
          </Link>
        </div>
      }
    >
      <LoaderBar isVisible={isLoading} />
      <SearchWithFilters
        onChangeInput={onChangeSearchTerm}
        searchTerm={searchTerm}
        onSearch={onSearch}
        placeholder={TEXT.searchPlaceholder}
        onClearInput={onClearInput}
      />

      <CompanyTable
        data={data}
        pagination={pagination}
        onClickPerPage={onChangePerPage}
        onPageChange={onChangePage}
      ></CompanyTable>
    </DashboardContainer>
  );
};

export default Companies;
